import * as React           from "react";
import {cx}                 from "emotion";
import {createElement as h} from "react";
import ReactTooltip         from 'react-tooltip';

import {AnyAction}          from "@Common/react/any-action";
import {consumeContext}     from "@Common/react/context";
import {cs}                 from "@Common/react/chain-services";
import {GlobalKeys}         from "@Common/react/global-keys-react";
import {Dropdown}           from "@Common/ui-components/dropdown/dropdown";
import {ModalService3}      from "@Common/ui-components/modal-service-3/modal-service-3";
import {parsePhpDate}       from "@Common/utils/date/parse-php-date";
import {upperCaseWord}      from "@Common/utils/strings";
import {TwoOptionModal}     from "@Xpresso/routes/common/two-option-modal/two-option-modal";

import "./manage-subscriptions-card.scss";

export const ManageSubscriptionsCard = ({agent, subscriptionPlans, activeSubscription, subscriptionModal}) => cs(
    consumeContext("apis"),
    ["reloadModal", (_, next) => ModalService3({
        xdQaName: "Subscription Details Modal",
        rootNext: next,
        next: (modal) => TwoOptionModal({
            messageLine1: modal.params,
            button1Label: "Refresh",
            button1Action: () => location.reload(),
            button2Label: "Cancel",
            button2Action: () => modal.close()
        })
    })],
    ["manageAction", ({apis, reloadModal}, next) => next(async () => {
        const portal = await apis.next.subscription.getPortal();
        if(portal?.statusCode == "success" && portal?.data?.url) {
            window.location.href = portal.data.url;
        } else if(portal?.message) {
            if(portal?.internalMessage) {
                reloadModal.show(portal.message + " " + portal.internalMessage);

            } else {
                reloadModal.show(portal.message);
            }
        } else {
            reloadModal.show("Something went wrong");
        }
    })],
    ({manageAction}) => (<>
        <div className="manage-subscriptions-card manage-subscriptions-card-d4d">
            <div className="section">
                <div className="card">
                    <div className="header">
                        <div className="agent-info">
                            <div className="name" xd-qa-type="label" xd-qa-name="Agent Name">
                                {agent.agentNameFirst && agent.agentNameFirst + ' '}
                                {agent.agentNameMiddle && agent.agentNameMiddle + ' '}
                                {agent.agentNameLast}
                            </div>
                            <div className="email" xd-qa-type="label" xd-qa-name="Agent Email">
                                {agent.agentEmail}
                            </div>
                        </div>
                        <div className="status">
                            {activeSubscription?.idScheduledPlanType && <span xd-qa-type="badge" xd-qa-name="Scheduled Change" className="badge primary">Scheduled Change</span>}
                            {getAccountStatus({
                                status: activeSubscription?.status,
                                getDataTip: () => activeSubscription?.cancellationReason ?? "",
                                resubscribe: ({planId}) => subscriptionModal.show({planId}),
                                subscriptionPlans,
                            })}
                        </div>
                    </div>
                    {subscriptionDetails.map((detail, i) => (
                        <React.Fragment key={i}>
                            {i !== 0 && <div className="sub-divider"/>}
                            <div className="display">
                                <div className="label">
                                    {detail.name === "Next Renewal" && activeSubscription?.idScheduledPlan ? "Scheduled Plan Change" : detail.name}
                                    {i === 0 && <a className="edit" xd-qa-type="link" xd-qa-name="Manage" onClick={() => manageAction()}>
                                        Manage
                                    </a>}
                                </div>
                                {detail.name === "Next Renewal" ? (
                                    <div className="value" xd-qa-type="label" xd-qa-name={detail.name}>
                                        {activeSubscription?.["status"] && (
                                            activeSubscription?.["status"] === "active" ? (
                                                detail.convert(activeSubscription?.[detail.id])
                                            ) : (
                                                "Cancelled"
                                            )
                                        )}
                                    </div>
                                ) : (
                                    <div className="value" xd-qa-type="label" xd-qa-name={detail.name}>
                                        {detail.convert(activeSubscription?.[detail.id])}
                                    </div>
                                )}
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    </>
    )
)

const getAccountStatus = ({status, resubscribe, subscriptionPlans, getDataTip}) => (
    status === "active" ? (
        <span xd-qa-type="badge" xd-qa-name="Active" className="badge active">Active</span>
    ) : status === "non_renewing" ? (
        <span xd-qa-type="badge" xd-qa-name="Cancellation Scheduled" className="badge warning">Cancellation Scheduled</span>
    ) : status === "cancelled" ? (
        <>
            <ReactTooltip  id="subscriptions" place="bottom" delayShow={100}/>
            <span
                xd-qa-type="badge"
                xd-qa-name="Cancelled"
                className="badge danger"
                data-for="subscriptions"
                data-tip={getDataTip()}
            >Cancelled</span>
            {/* {resubscribeDropDown({resubscribe, subscriptionPlans})} */}
        </>
    ) : (
        ""
    )
)

const resubscribeDropDown = ({resubscribe, subscriptionPlans}) => (
    Dropdown({
        renderToggle: ({domRef, showExpand, showingExpand}) => (
            <a
                className="resubscribe"
                xd-qa-type="dropdown"
                xd-qa-name="Resubscribe"
                ref={domRef}
                onClick={(e) => showExpand()}
            >
               Resubscribe <i className={`fa ${showingExpand ? "fa-caret-up" : "fa-caret-down"}`}></i>
            </a>
        ),

        renderExpand: ({close, domRef, position}) => (
            <div
                className={cx("expand", {capture: true})}
                onClick={close}
                ref={domRef}
            >
                <GlobalKeys {...{
                    keyCombo: "Escape",
                    onKeyDown: close,
                }} />
                <div
                    className="dropdown"
                    style={position}
                    ref={domRef}
                >
                    {h(AnyAction, {
                        action: close,
                    })}
                    {subscriptionPlans.map((plan) =>
                        <div className="dropdown-item" key={plan.id} xd-qa-type="dropdown_item" xd-qa-name={plan.label}>
                            <div
                                className={cx("plan",{"best-choice": plan.bestChoice})}
                                onClick={() => resubscribe({planId: plan.id})}
                            >
                                <div className="name">{plan.label}</div>
                                <div className="right">
                                    <div className="dollar">$</div>
                                    <div className="cost">{plan.cost}</div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    })
)

const subscriptionDetails = [
    {
        id: "label",
        name: "Plan",
        convert: (v) => v,
    },
    {
        id: "dateSubscribed",
        name: "Member Since",
        convert: (d) => d && parsePhpDate(d).toLocaleDateString('en-US')
    },
    {
        id: "renewalFrequency",
        name: "Renewal Frequency",
        convert: (text) => text && upperCaseWord(text) + "ly"
    },
    {
        id: "dateNextRenewal",
        name: "Benefits Through",
        convert: (d) => {
            if(d)
            {
                let date = parsePhpDate(d)
                date.setDate(date.getDate() - 1);
                return date.toLocaleDateString('en-US');
            }
        }
    },
    {
        id: "dateNextRenewal",
        name: "Next Renewal",
        convert: (d) => d && parsePhpDate(d).toLocaleDateString('en-US')
    },
];